import reporter from "../report/reporter";
import { getPage } from "../shared/global";
import { getAttribute } from "./get";

export function dialog_expose(targetNode) {
  const page = getPage();
  const trackData = {
    event_id: 39012,
    event_name: "dialog_expose",
    title: getAttribute(targetNode, "data-dialog-title"),
    ...page,
  };

  const { page_nm, sub_page_nm } = page;
  var source = getAttribute(targetNode, "data-content-source");

  if (source) {
    trackData.source = `${page_nm}_${sub_page_nm || ""}_${source}`;
  } else {
    trackData.source = sub_page_nm ? `${page_nm}_${sub_page_nm}` : page_nm;
  }

  var module_name = getAttribute(targetNode, "data-module-name");
  if (module_name) {
    trackData.module_name = module_name;
  }

  var subject_name = getAttribute(targetNode, "data-subject-name");
  if (subject_name) {
    trackData.subject_name = subject_name;
  }

  var search_word = getAttribute(targetNode, "data-search-word");
  if (search_word) {
    trackData.search_word = search_word;
  }

  var repository_type = getAttribute(targetNode, "data-repository-type");
  if (repository_type) {
    trackData.repository_type = repository_type;
  }

  var account_type = getAttribute(targetNode, "data-account-type");
  if (account_type) {
    trackData.account_type = account_type;
  }
  let plan_id = getAttribute(targetNode, "data-plan-id");
  if (plan_id) {
    trackData.plan_id = plan_id;
  }
  let create_id = getAttribute(targetNode, "data-create-id");
  if (create_id) {
    trackData.create_id = create_id;
  }

  let board_id = getAttribute(targetNode, "data-board-id");
  if (board_id) {
    trackData.board_id = board_id;
  }

  reporter(trackData);
}

export function dialog_action(targetNode) {
  const page = getPage();
  const trackData = {
    event_id: 39013,
    event_name: "dialog_action",
    title: getAttribute(targetNode, "data-dialog-title"),
    action_type: getAttribute(targetNode, "data-dialog-action"),
    ...page,
  };
  const { page_nm, sub_page_nm } = page;
  var source = getAttribute(targetNode, "data-content-source");

  if (source) {
    trackData.source = `${page_nm}_${sub_page_nm || ""}_${source}`;
  } else {
    trackData.source = sub_page_nm ? `${page_nm}_${sub_page_nm}` : page_nm;
  }

  var message_id = getAttribute(targetNode, "data-message-id");
  if (message_id) {
    trackData.message_id = message_id;
  }

  var dialog_content = getAttribute(targetNode, "data-dialog-content");
  if (dialog_content) {
    trackData.dialog_content = dialog_content;
  }

  var button_name = getAttribute(targetNode, "data-button-name");
  if (button_name) {
    trackData.button_name = button_name;
  }
  let plan_id = getAttribute(targetNode, "data-plan-id");
  if (plan_id) {
    trackData.plan_id = plan_id;
  }
  let create_id = getAttribute(targetNode, "data-create-id");
  if (create_id) {
    trackData.create_id = create_id;
  }

  let board_id = getAttribute(targetNode, "data-board-id");
  if (board_id) {
    trackData.board_id = board_id;
  }
  reporter(trackData);
}
